import { html } from 'omni-ui';
import {
  Om2FormFieldBase,
  mergeClass,
  wrapWithLink,
  renderTooltip,
  SHARED_FIELD,
} from './common/base.js';

/**
 * Render text
 * This is a layout field, not an input field.
 */
export class Om2FormFieldText extends Om2FormFieldBase {
  static metadata = {
    layout: true,
    config: {
      maxContents: 0,
      summary: 'text',
      fields: {
        text: {
          title: 'Text',
          type: 'string',
          multiline: true,
          required: true,
          formModal: { fullWidth: true },
        },
        size: {
          title: 'Text Size (1-7)',
          type: 'number',
          min: 1,
          max: 7,
          multipleOf: 1,
        },
        class: {
          title: 'CSS Class',
          tooltip:
            'This is a space separated list of css classes (typically from bulma/omni-ui)',
          type: 'string',
        },
        title: SHARED_FIELD,
        tooltip: SHARED_FIELD,
        preformatted: {
          type: 'boolean',
          title: 'Preformatted Text',
          tooltip:
            'Whitespace characters including spaces, tabs, and line breaks are preserved',
          default: false,
        },
        url: SHARED_FIELD,
      },
    },
  };

  render() {
    const { schema } = this;
    const text = schema.preformatted
      ? html`<span style="white-space: pre">${schema.text}</span>`
      : schema.text;
    const innerHTML = html` <p
      class=${mergeClass(`is-size-${schema.size ?? 4}`, schema.class)}
    >
      ${text} ${renderTooltip(schema)}
    </p>`;
    return wrapWithLink(schema.url, innerHTML);
  }
}

Om2FormFieldText.register('text');
